module.exports = __webpack_public_path__ + "img/csgo.c3ed7ef5.png";